import { chakra } from '@chakra-ui/react';
import React from 'react';

import { useAdmonitionStyles } from '../Admonition/Admonition.context';

export interface AdmonitionFooterProps {
  children: React.ReactNode;
}

export const AdmonitionFooter = ({ children }: AdmonitionFooterProps) => {
  const styles = useAdmonitionStyles();
  return <chakra.div __css={styles.footer}>{children}</chakra.div>;
};
